module.exports = __webpack_public_path__ + "media/early colorectal cancer.90981d93.wav";